const daysAgo = (days, hours = 12, minutes = 0) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  date.setHours(hours, minutes, 0, 0);
  return date.toISOString();
};

const SCENARIO_DEMOS = [
  {
    name: "Популярный сценарий",
    analytics: {
      starts: 847,
      completions: 612,
      uniquePlayers: 523,
      errors: 1342,
    },
    sessions: [
      {
        id: "demo-1-1",
        displayName: "Анна (@anna_k)",
        startedAt: daysAgo(1, 14, 32),
        completedAt: daysAgo(1, 14, 58),
        completed: true,
        errors: 1,
        path: ["Старт", "Приветствие", "Выбор инструмента", "Практика", "Финал"],
      },
      {
        id: "demo-1-2",
        displayName: "Дмитрий (@dm_tools)",
        startedAt: daysAgo(2, 9, 15),
        completedAt: daysAgo(2, 9, 41),
        completed: true,
        errors: 0,
        path: ["Старт", "Приветствие", "Теория", "Тест", "Финал"],
      },
      {
        id: "demo-1-3",
        displayName: "Елена (@elena_m)",
        startedAt: daysAgo(2, 18, 4),
        completedAt: daysAgo(2, 18, 22),
        completed: true,
        errors: 2,
        path: ["Старт", "Приветствие", "Выбор инструмента", "Практика", "Финал"],
      },
      {
        id: "demo-1-4",
        displayName: "Игорь (@igor_v)",
        startedAt: daysAgo(3, 11, 47),
        completedAt: null,
        completed: false,
        errors: 4,
        path: ["Старт", "Приветствие", "Теория"],
      },
      {
        id: "demo-1-5",
        displayName: "Мария (@maria_p)",
        startedAt: daysAgo(4, 16, 20),
        completedAt: daysAgo(4, 16, 55),
        completed: true,
        errors: 0,
        path: ["Старт", "Приветствие", "Теория", "Тест", "Финал"],
      },
      {
        id: "demo-1-6",
        displayName: "Сергей (@serg42)",
        startedAt: daysAgo(5, 8, 3),
        completedAt: daysAgo(5, 8, 39),
        completed: true,
        errors: 3,
        path: [
          "Старт",
          "Приветствие",
          "Выбор инструмента",
          "Практика",
          "Тест",
          "Финал",
        ],
      },
      {
        id: "demo-1-7",
        displayName: "Ольга (@olga_s)",
        startedAt: daysAgo(6, 20, 11),
        completedAt: null,
        completed: false,
        errors: 1,
        path: ["Старт", "Приветствие"],
      },
    ],
  },
  {
    name: "Новый сценарий в работе",
    analytics: {
      starts: 23,
      completions: 2,
      uniquePlayers: 18,
      errors: 47,
    },
    sessions: [
      {
        id: "demo-2-1",
        displayName: "Тестер (@qa_bot)",
        startedAt: daysAgo(0, 10, 5),
        completedAt: null,
        completed: false,
        errors: 12,
        path: ["Старт", "Сцена 1", "Сцена 2", "Сцена 1"],
      },
      {
        id: "demo-2-2",
        displayName: "Автор (@you)",
        startedAt: daysAgo(1, 22, 40),
        completedAt: daysAgo(1, 23, 8),
        completed: true,
        errors: 5,
        path: ["Старт", "Сцена 1", "Сцена 2", "Сцена 3", "Финал"],
      },
      {
        id: "demo-2-3",
        displayName: "Коллега (@colleague)",
        startedAt: daysAgo(2, 15, 18),
        completedAt: null,
        completed: false,
        errors: 8,
        path: ["Старт", "Сцена 1"],
      },
      {
        id: "demo-2-4",
        displayName: "Никита (@nick_dev)",
        startedAt: daysAgo(3, 13, 0),
        completedAt: daysAgo(3, 13, 25),
        completed: true,
        errors: 2,
        path: ["Старт", "Сцена 1", "Сцена 2", "Сцена 3", "Финал"],
      },
      {
        id: "demo-2-5",
        displayName: "Бeta User 104",
        startedAt: daysAgo(4, 9, 44),
        completedAt: null,
        completed: false,
        errors: 6,
        path: ["Старт"],
      },
    ],
  },
  {
    name: "Групповой сценарий",
    analytics: {
      starts: 156,
      completions: 89,
      uniquePlayers: 134,
      errors: 218,
    },
    sessions: [
      {
        id: "demo-3-1",
        displayName: "Команда «Альфа»",
        startedAt: daysAgo(1, 9, 0),
        completedAt: daysAgo(1, 9, 52),
        completed: true,
        errors: 0,
        path: ["Старт", "Брифинг", "Задание A", "Задание B", "Итоги"],
      },
      {
        id: "demo-3-2",
        displayName: "Павел (@pavel_g)",
        startedAt: daysAgo(1, 9, 3),
        completedAt: daysAgo(1, 10, 14),
        completed: true,
        errors: 4,
        path: ["Старт", "Брифинг", "Задание A", "Задание C", "Итоги"],
      },
      {
        id: "demo-3-3",
        displayName: "Юлия (@yulia_k)",
        startedAt: daysAgo(2, 14, 27),
        completedAt: null,
        completed: false,
        errors: 7,
        path: ["Старт", "Брифинг", "Задание A"],
      },
      {
        id: "demo-3-4",
        displayName: "Группа «Бета-2» (4 чел.)",
        startedAt: daysAgo(3, 11, 10),
        completedAt: daysAgo(3, 12, 5),
        completed: true,
        errors: 11,
        path: [
          "Старт",
          "Брифинг",
          "Задание B",
          "Задание A",
          "Задание C",
          "Итоги",
        ],
      },
      {
        id: "demo-3-5",
        displayName: "Артём (@artem)",
        startedAt: daysAgo(4, 17, 55),
        completedAt: null,
        completed: false,
        errors: 2,
        path: ["Старт", "Брифинг"],
      },
      {
        id: "demo-3-6",
        displayName: "Виктория (@vika_m)",
        startedAt: daysAgo(5, 8, 30),
        completedAt: daysAgo(5, 9, 18),
        completed: true,
        errors: 1,
        path: ["Старт", "Брифинг", "Задание C", "Итоги"],
      },
    ],
  },
];

function hasRealAnalytics(game) {
  const analytics = game?.analytics ?? {};
  const sessions = game?.playSessions ?? [];

  const hasSummary =
    (analytics.starts ?? 0) > 0 ||
    (analytics.completions ?? 0) > 0 ||
    (analytics.uniquePlayers ?? 0) > 0 ||
    (analytics.errors ?? 0) > 0;

  return sessions.length > 0 || hasSummary;
}

export function getAnalyticsDemoVariant(gameId, games) {
  if (!gameId) {
    return SCENARIO_DEMOS[0];
  }

  const index = games?.findIndex((item) => item._id === gameId);
  const variantIndex =
    index >= 0 ? index % SCENARIO_DEMOS.length : 0;

  return SCENARIO_DEMOS[variantIndex];
}

export function resolveAnalyticsView(game, games) {
  if (hasRealAnalytics(game)) {
    return {
      analytics: game.analytics ?? {},
      sessions: game.playSessions ?? [],
      isDemo: false,
      demoLabel: null,
    };
  }

  const demo = getAnalyticsDemoVariant(game?._id, games);

  return {
    analytics: demo.analytics,
    sessions: demo.sessions,
    isDemo: true,
    demoLabel: demo.name,
  };
}

export function formatAnalyticsCount(value) {
  return new Intl.NumberFormat("ru-RU").format(value ?? 0);
}

export function getProjectAnalyticsPreview(game, games) {
  const { analytics, isDemo } = resolveAnalyticsView(game, games);
  const starts = analytics.starts ?? 0;
  const completions = analytics.completions ?? 0;
  const uniquePlayers = analytics.uniquePlayers ?? 0;
  const conversion = starts > 0 ? Math.round((completions / starts) * 100) : 0;

  return {
    starts,
    completions,
    uniquePlayers,
    conversion,
    isDemo,
    hasData: starts > 0 || completions > 0 || uniquePlayers > 0,
  };
}
